<template>
  <div>
    <v-flex>
      <v-dialog v-model="dialog.siak"
        @keydown.esc="dialog.siak = false"
        :fullscreen="dialog.fullscreen"
        :width="form.url.length > 0 ? 1400 : 600"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Update Data dari SIAK
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.siak = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text 
            class="pt-2 pa-4 body-1 line-text-second">
            <ValidationObserver ref="form">
              <v-form class="text-left">
                <v-row>
                  <v-col
                    :cols="form.url.length > 0 ? 5 : 12"
                    class="py-0">
                    <div>
                      <div
                        class="text-h5 font-weight-bold black--text mb-4">
                        #{{ selected.detail.prod_ajuan_no_reg }}
                      </div>

                      <div
                        class="mb-2">
                        <div 
                          class="body-2">
                          <!-- Nomor (KK/KTP-EL/DLL) -->
                          Nomor Identitas
                        </div>

                        <div v-if="user.level !== 'administrator'"
                          class="title font-weight-bold black--text">
                          {{ selected.detail.prod_nomor }}
                        </div>

                        <ValidationProvider
                          name="nomor" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <v-text-field
                            class="mt-2 mb-5"
                            style="max-width: 70%;"
                            :style="user.level !== 'administrator' ? 'display: none;' : ''"
                            dense
                            outlined
                            color="#ff64ad"
                            hide-details
                            placeholder="Contoh. 33100062XXXXXXX"
                            v-model="form.nomor"
                            v-uppercase
                            :success="form.nomor !== '' && valid"
                            :error-messages="errors">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Nomor {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.nomor !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </div>

                      <div
                        class="mb-4">
                        <ValidationProvider 
                          name="nama" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div
                            class="body-2">
                            <!-- Nama (Nama Kepala Keluarga/Nama Lengkap/DLL) -->
                            Nama Identitas Produk
                          </div>

                          <div v-if="user.level !== 'administrator'"
                            class="title font-weight-bold black--text">
                            {{ selected.detail.prod_nama }}
                          </div>

                          <v-text-field
                            style="max-width: 70%;"
                            :style="user.level !== 'administrator' ? 'display: none;' : ''"
                            class="mt-2 mb-5"
                            dense
                            outlined
                            color="#ff64ad"
                            hide-details
                            placeholder="Contoh. Fabdulrafi"
                            v-model="form.nama"
                            v-uppercase
                            :success="form.nama !== '' && valid"
                            :error-messages="errors">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Nama {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.nama !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </div>

                      <div
                        class="pa-2 px-3 orange--text mb-6"
                        style="border: 1px solid #fff;
                              border-radius: 7px;
                              border-style: dashed;
                              background: #ff980033;">
                        <span v-if="selected.detail.prod_layanan_kode !== 'KTP'">
                          Silahkan update status serta upload dokumen dari data ajuan yang sudah diverifikasi dan divalidasi di SIAK.
                        </span>

                        <span v-else>
                          Silahkan update dari data ajuan yang sudah diverifikasi dan divalidasi di SIAK.
                        </span>
                      </div>
                    </div>

                    <ValidationProvider 
                      name="status" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Status
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <v-select
                        style="max-width: 60%;"
                        outlined
                        dense
                        color="#ff64ad"
                        :placeholder="selected.detail.prod_layanan_kode === 'KTP' ? 'Contoh. SIAP DICETAK' : 'Contoh. DIAJUKAN TTE'"
                        
                        :items="selected.detail.prod_layanan_kode === 'KTP' ?
                          [
                            'SIAP DICETAK',
                            'SUDAH DICETAK',
                            'SIAP DIAMBIL',
                            'SUDAH DIAMBIL',
                            'TIDAK DIPROSES'
                          ] :
                          selected.detail.prod_layanan_kode === 'KK' ?
                          [
                            'DIAJUKAN TTE',
                            'TIDAK DIPROSES',
                            'SIAP DIDOWNLOAD'
                          ] : 
                          selected.detail.prod_layanan_kode === 'KIA' ?
                          [
                            'DIAJUKAN TTE',
                            'SIAP DICETAK',
                            'SUDAH DICETAK',
                            'SIAP DIAMBIL',
                            'SUDAH DIAMBIL',
                            'TIDAK DIPROSES'
                          ] :
                          [
                            'DIAJUKAN TTE',
                            'SIAP DIDOWNLOAD'
                          ]"
                        item-color="#ff64ad"

                        hide-details

                        v-model="form.status"
                        :success="form.status.length > 0 && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Status {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.status.length > 0 && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-select>
                    </ValidationProvider>

                    <div v-if="form.status === 'TIDAK DIPROSES'"
                      class="mt-6">
                      <div class="body-2 mb-2">
                        Keterangan
                        <span>
                          (boleh dikosongi)
                        </span>
                      </div>

                      <quill-editor 
                        ref="myTextEditor"
                        :options="{
                          placeholder: 'Contoh. Alasan kenapa tidak diproses'
                        }"
                        v-model="form.note">
                      </quill-editor>
                    </div>

                    <div v-if="selected.detail.prod_layanan_kode !== 'KTP' && selected.detail.prod_layanan_kode !== 'KIA' && (form.status === 'DIAJUKAN TTE' || form.status === 'SIAP DIDOWNLOAD')"
                      class="mt-6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Upload Dokumen SIAK
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>

                      <uploadfile v-model="files">
                        <div slot="activator">
                          <v-btn
                            :disabled="process.file"
                            :loading="process.file"
                            color="#333333"
                            elevation="0"
                            class="body-2 font-weight-bold text-capitalize white--text px-2">
                            <v-icon size="20" class="mr-1">mdi-file-pdf-box</v-icon>
                            {{ form.url.length > 0 ? 'Ubah' : 'Tambah' }} Dokumen
                          </v-btn>
                        </div>
                      </uploadfile>

                      <div v-if="form.status === 'SIAP DIDOWNLOAD' && (!form.url || form.url === '')"
                        class="caption red--text mt-2 font-weight-medium d-flex align-center">
                        <v-icon x-small color="red" class="mr-1">mdi-alert-circle</v-icon>
                        Dokumen SIAK wajib diupload untuk status SIAP DIDOWNLOAD
                      </div>

                      <div v-if="form.url.length > 0"
                        class="body-2 mt-4">
                        <div class="font-weight-light font-italic mb-2">
                          Untuk melihat dokumen yang di upload, klik link di bawah ini :
                        </div>

                        <a :href="form.url" target="_blank">
                          {{ form.url }}
                        </a>
                      </div>
                    </div>
                  </v-col>

                  <v-col v-if="form.url.length > 0"
                    cols="7"
                    class="py-0">
                    <iframe 
                      :src="`${form.url}`" 
                      allowfullscreen
                      frameborder="0" 
                      width="100%"
                      height="650"
                      style="border-radius: 15px; border: 2px solid #323639;">
                    </iframe>
                  </v-col>
                </v-row>

                <v-alert 
                  type="error" 
                  text dense prominent 
                  class="mt-6"
                  v-show="message.error.length > 0">
                  {{  message.error }}
                </v-alert>
              </v-form>
            </ValidationObserver>
          </v-card-text>

          <v-divider class="mx-4 mb-3 mt-2"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              :disabled="process.form"
              :loading="process.form"
              @click="save()">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="dialog.siak = false; reset();">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.add"
        @keydown.esc="dialog.add = false"
        :fullscreen="dialog.fullscreen"
        width="600"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Tambah Produk
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.add = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <Add
            :detail="selected.add"
            @close="dialog.add = $event"
            @product="fetchProduct()" />
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.delete"
        @keydown.esc="dialog.delete = false"
        :fullscreen="dialog.fullscreen"
        width="475"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Hapus Produk
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.delete = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text 
            class="pt-2 pa-4 body-1 font-weight-light line-text-second">
            Apakah Anda yakin menghaps produk yang Anda pilih ?
          </v-card-text>

          <v-divider class="mx-4 mb-3 mt-2"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              :disabled="process.form"
              :loading="process.form"
              @click="save_delete()">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="dialog.delete = false">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <section>
        <v-row v-if="process.load && Object.keys(detail).length < 1">
          <v-col 
            cols="12"
            md="3"
            class="pb-0">
            <v-skeleton-loader
              type="image, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>

          <v-col 
            cols="12"
            md="9"
            class="pb-0">
            <v-skeleton-loader
              type="article, list-item-three-line, article, list-item-three-line, article, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <div v-if="!process.load && Object.keys(detail).length > 0"
          class="pb-0">
          <v-row>
            <v-col 
              cols="12"
              md="3"
              class="pb-0">
              <div style="position: sticky; top: 96px;">
                <a href="/product"
                  class="d-flex align-center color-first cursor-pointer mb-4">
                  <v-icon color="#ff64ad">mdi-arrow-left-thick</v-icon>
              
                  <span class="body-1 ml-1">
                    Kembali
                  </span>
                </a>

                <v-card
                  class="my-2 pa-2"
                  style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
                        border-radius: 10px;">
                  <v-card-text
                    class="text-center">
                    Pengaju / Pelapor
                  </v-card-text>

                  <v-card-text
                    class="text-center">
                    <v-avatar 
                      size="125"
                      style="box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;">
                      <v-img
                        width="125"
                        height="125"
                        alt="vuetify"
                        :src="detail.pelapor_image.length < 1 ? require('@/assets/image/member-default.jpg') : detail.pelapor_image">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#ff64ad">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                  </v-card-text>

                  <v-card-title
                    class="d-flex justify-center font-weight-bold">
                    <span
                      class="one-line">
                      {{ detail.pelapor_fullname }}
                    </span>
                  </v-card-title>

                  <v-card-subtitle
                    class="text-center">
                    <div
                      class="my-1">
                      NIK. {{ detail.ajuan_pelapor_nik }}
                    </div>

                    <div
                      class="my-1">
                      Email. {{ detail.ajuan_is_mandiri ? detail.pelapor_email : detail.pelapor_extra.instansi_email }}
                    </div>

                    <div>
                      Telepon. {{ detail.ajuan_is_mandiri ? detail.pelapor_phone : detail.pelapor_extra.instansi_phone }}
                    </div>
                  </v-card-subtitle>

                  <v-card-text
                    class="pb-2">
                    <v-row>
                      <v-col
                        cols="5"
                        class="text-center">
                        <div
                          class="mb-1">
                          Tipe Ajuan
                        </div>

                        <div
                          class="body-1 font-weight-bold"
                          :class="detail.ajuan_is_online ? 'blue--text' : ''">
                          {{ detail.ajuan_is_online ? 'Online' : 'Offline' }}
                        </div>
                      </v-col>

                      <v-col
                        cols="2"
                        class="text-center">
                        <v-divider vertical />
                      </v-col>

                      <v-col
                        cols="5"
                        class="text-center">

                        <div
                          class="mb-1">
                          Kategori Ajuan
                        </div>

                        <div
                          class="body-1 font-weight-bold"
                          :class="detail.ajuan_is_mandiri ? 'green--text' : 'red--text'">
                          <!-- {{ detail.ajuan_is_mandiri ? 'Mandiri' : 'Group' }} -->
                          {{ detail.ajuan_pelapor_role_name }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text v-if="(detail.ajuan_status !== 'BELUM DIVERIFIKASI' || detail.ajuan_status !== 'DIKOREKSI') && Object.keys(detail.ajuan_extra).length > 0"
                    class="pb-0">
                    <div
                      class="font-italic"
                      style="opacity: 60%;">
                      *Ajuan sedang diperiksa / dikerjakan oleh operator berikut:
                    </div>

                    <v-list 
                      flat 
                      color="transparent"
                      three-line>
                      <v-list-item
                        class="mb-0"
                        style="border-radius: 5px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;
                              background: #fff;
                              cursor: auto;">
                        <v-list-item-avatar 
                          tile 
                          size="50"
                          class="mr-3">
                          <v-img 
                            style="border-radius: 5px;"
                            alt="kominfo" 
                            :src="detail.ajuan_extra.admin_proses_verifikasi.image"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="#ff64ad">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title 
                            class="body-2 font-weight-bold">
                            {{ detail.ajuan_extra.admin_proses_verifikasi.fullname }}
                          </v-list-item-title>

                          <v-list-item-subtitle 
                            class="caption font-weight-light black--text">
                            <div
                              class="d-flex align-center"
                              style="margin-bottom: 5px;">
                              <v-icon size="16">mdi-email</v-icon>

                              <span
                                class="one-line ml-1">
                                {{ detail.ajuan_extra.admin_proses_verifikasi.email === '' || detail.ajuan_extra.admin_proses_verifikasi.email === null ? 'xxxx@gmail.com' : detail.ajuan_extra.admin_proses_verifikasi.email }}
                              </span>
                            </div>

                            <div
                              class="d-flex align-center">
                              <v-icon size="16">mdi-phone</v-icon>

                              <span
                                class="one-line ml-1">
                                {{ detail.ajuan_extra.admin_proses_verifikasi.phone === '' || detail.ajuan_extra.admin_proses_verifikasi.phone === null ? 'xxxx-xxxx-xxxx' : detail.ajuan_extra.admin_proses_verifikasi.phone }}
                              </span>
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col 
              cols="12"
              md="9"
              class="pb-0">
              <v-card
                class="pa-2"
                min-height="85.5vh"
                style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
                      border-radius: 0px 10px 10px 10px;">
                <v-card-title
                  class="text-h5 font-weight-bold mb-1">
                  #{{ detail.ajuan_no_reg }}
                </v-card-title>

                <v-card-subtitle
                  class="mb-2">
                  {{ detail.ajuan_layanan_kode }} - 

                  <span
                    :class="detail.ajuan_status === 'BELUM DIVERIFIKASI' ? 'orange--text' :
                            detail.ajuan_status === 'PROSES VERIFIKASI' ? 'blue--text' :
                            detail.ajuan_status === 'DISETUJUI' ? 'cyan--text' :
                            detail.ajuan_status === 'DISETUJUI TANPA NIK' ? 'indigo--text' :
                            detail.ajuan_status === 'DISETUJUI TERBIT NIK' ? 'lime--text' :
                            detail.ajuan_status === 'DIKOREKSI' ? 'purple--text' :
                            detail.ajuan_status === 'SELESAI DIPROSES' ? 'green--text' : 'red--text'">
                    {{ detail.ajuan_status }}
                  </span>
                </v-card-subtitle>

                <v-card-text
                  class="pb-0"
                  style="opacity: 80%;">
                  <v-icon small>mdi-calendar-month</v-icon>

                  Diajukan pada Tanggal <b>{{ detail.ajuan_create_datetime | date }}</b> Pukul <b>{{ detail.ajuan_create_datetime | time }}</b>
                </v-card-text>

                <v-card-text>
                  <v-btn v-if="!process.product && pagination.product.total_data > 0 && detail.ajuan_status !== 'SELESAI DIPROSES'"
                    @click="dialog.add = true; selected.add = detail;"
                    elevation="0"
                    style="background: #00acc133;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1 my-4">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah Produk
                    </span>
                  </v-btn>
                  
                  <v-list 
                    flat 
                    color="transparent"
                    three-line>
                    <v-list-item-group>
                      <v-skeleton-loader
                        v-for="(item, index) in process.product ? 5 : list.product"
                        :key="index"
                        class="ma-auto"
                        :loading="process.product"
                        type="list-item-avatar-three-line">
                        <template>
                          <div>
                            <v-list-item v-if="!process.product && list.product.length > 0"
                              :class="index < list.product.length - 1 ? 'mb-4' : ''"
                              class="pl-3"
                              style="border-radius: 5px;
                                    border: 2px solid #eaeaea; 
                                    border-style: dashed;
                                    background: #fff;
                                    cursor: auto;">
                              <v-list-item-avatar 
                                tile 
                                size="50"
                                class="mr-3">
                                <v-img 
                                  style="border-radius: 5px;"
                                  alt="kominfo" 
                                  :src="require(`@/assets/image/service/${item.prod_layanan_kode}.png`)"
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        color="#ff64ad">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title 
                                  class="body-2 font-weight-bold">
                                  {{ item.prod_layanan_kode }} - {{ item.prod_nomor }}
                                </v-list-item-title>

                                <v-list-item-subtitle 
                                  class="caption font-weight-light black--text my-2" 
                                  style="opacity: 60%;">
                                  <div
                                    style="margin-bottom: 7px;">
                                    <span
                                      class="one-line text-uppercase">
                                      {{ item.prod_nama }}
                                    </span>
                                  </div>

                                  <div
                                    class="font-weight-bold"
                                    :class="item.prod_status === 'BELUM DIVERIFIKASI' || item.prod_status === 'BELUM DIAJUKAN TTE' ? 'orange--text' :
                                            item.prod_status === 'TIDAK DIPROSES' ? 'red--text' : 'cyan--text'">
                                    <span
                                      class="one-line">
                                      {{ item.prod_status }}
                                    </span>
                                  </div>
                                </v-list-item-subtitle>

                                <v-list-item-subtitle 
                                  class="caption font-weight-light black--text">
                                  <span
                                    class="one-line">
                                    {{ item.prod_create_datetime | date }}
                                  </span>
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action
                                class="d-flex align-center">
                                <div
                                  class="d-flex align-center">
                                  <v-btn v-if="item.prod_status !== 'SIAP DIDOWNLOAD' && 
                                              item.prod_status !== 'SUDAH DIAMBIL'"
                                    @click="dialog.siak = true; selected.detail = item; fetchStatus(); reset(item);"
                                    width="110"
                                    small
                                    elevation="0"
                                    style="background: #ff64ad33;"
                                    class="caption text-capitalize font-weight-bold d-flex align-center color-first px-2">
                                    <v-icon small>mdi-list-status</v-icon>
                                    
                                    <span
                                      class="ml-1">
                                      Proses SIAK
                                    </span>
                                  </v-btn>

                                  <v-btn v-if="item.prod_status === 'SIAP DIDOWNLOAD'"
                                    :href="item.prod_url"
                                    target="_blank"
                                    small
                                    elevation="0"
                                    style="background: #00800033;"
                                    class="caption text-capitalize font-weight-bold d-flex align-center green--text px-2">
                                    <v-icon small>mdi-download</v-icon>
                                    
                                    <span
                                      class="ml-1">
                                      {{ item.prod_status }}
                                    </span>
                                  </v-btn>

                                  <v-btn v-if="item.prod_status === 'SUDAH DIAMBIL'"
                                    @click="dialog.siak = true; selected.detail = item; fetchStatus(); reset(item);"
                                    small
                                    elevation="0"
                                    style="background: #00800033;"
                                    class="caption text-capitalize font-weight-bold d-flex align-center green--text px-2">
                                    <v-icon small>mdi-card-account-details-outline</v-icon>
                                    
                                    <span
                                      class="ml-1">
                                      {{ item.prod_status }}
                                    </span>
                                  </v-btn>

                                  <v-btn v-if="user.level === 'administrator'"
                                    @click="dialog.siak = true; selected.detail = item; fetchStatus(); reset(item);"
                                    icon
                                    small
                                    elevation="0"
                                    style="background: #2197f333;"
                                    class="caption text-capitalize font-weight-bold d-flex align-center blue--text ml-3">
                                    <v-icon small>mdi-pencil-outline</v-icon>
                                  </v-btn>

                                  <v-btn v-if="user.level === 'administrator'"
                                    @click="dialog.delete = true; selected.detail = item;"
                                    icon
                                    small
                                    elevation="0"
                                    style="background: #ff000033;"
                                    class="caption text-capitalize font-weight-bold d-flex align-center red--text ml-3">
                                    <v-icon small>mdi-delete-empty</v-icon>
                                  </v-btn>
                                </div>
                              </v-list-item-action>
                            </v-list-item>
                          </div>
                        </template>
                      </v-skeleton-loader>
                    </v-list-item-group>
                  </v-list>

                  <Empty v-if="!process.product && pagination.product.total_data < 1"
                    margin="my-10"
                    padding="pa-16"
                    font="body-2"
                    :size="150"
                    message="Produk" />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>
    </v-flex>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          siak: false,
          add: false,
          delete: false
        },
        selected: {
          detail: {},
          add: false
        },
        detail: {},
        list: {
          product: [],
          status: []
        },
        pagination: {
          product: {}
        },
        files: null,
        form: {
          id: '',
          ajuan_id: '',
          nomor: '',
          layanan_kode: '',
          nama: '',
          status: '',
          note: '',
          url: ''
        },
        process: {
          load: false,
          product: false,
          form: false,
          file: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Add: () => import(/* webpackPrefetch: true */ '@/components/verification/add.vue'),
      uploadfile: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.menu': function(val) {
        if (val === 1) {
          this.fetchLog()
        } else if (val === 2) {
          this.fetchProduct()
        }
      },
      'files': {
        handler: function () {
          if (this.files) {
            this.process.file = this.files.process 

            if (!this.process.file) {
              this.form.url = this.files.data.file_url
              if (this.message.error) {
                this.message.error = ''
              }
            }
          }
        },
        deep: true
      },
      'form.status': function(val) {
        if (val === 'TIDAK DIPROSES') this.form.url = ''
        if (val !== 'SIAP DIDOWNLOAD' && this.message.error.includes('SIAP DIDOWNLOAD')) {
          this.message.error = ''
        }
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`admin/ajuan/${this.$route.path.split('/')[2]}/detail`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.load = false
            
            this.detail = res.data

            this.fetchProduct()
          }
        })
      },
      async fetchProduct () {
        this.process.product = true
        
        let params = {
          prod_ajuan_id: this.detail.ajuan_id,
          order_by: 'ASC'
        }

        await get(`admin/produk/list`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.product = false
            
            this.list.product = res.data
            this.pagination.product = res.pagination
          }
        })
      },
      async fetchStatus () {
        // let params = {
        //   limit: 10000
        // }

        // await get('master/status_produk', { params })
        // .then(response => {
        //   let res = response.data

        //   if (res.code === 200) {
        //     this.list.status = res.data
        //   }
        // })

        this.list.status = [
          'SIAP DIDOWNLOAD',
          'SUDAH DICETAK',
          'SIAP DIAMBIL',
          'SIAP DIKIRIM',
          'SUDAH DITERIMA',
        ]
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.form = {
          id: item !== undefined ? item.prod_id : '',
          ajuan_id: item !== undefined ? item.prod_ajuan_id : '',
          nomor: item !== undefined ? item.prod_nomor : '',
          layanan_kode: item !== undefined ? item.prod_layanan_kode : '',
          nama: item !== undefined ? item.prod_nama : '',
          status: item !== undefined ? item.prod_status : '',
          // status: '',
          note: item !== undefined ? item.prod_extra.note : '',
          url: item !== undefined ? item.prod_url : ''
        }
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          if (this.selected.detail.prod_layanan_kode !== 'KTP' && this.selected.detail.prod_layanan_kode !== 'KIA' && this.form.status === 'SIAP DIDOWNLOAD' && (!this.form.url || this.form.url.trim() === '')) {
            this.message.error = 'Dokumen SIAK wajib diupload sebelum mengubah status menjadi SIAP DIDOWNLOAD.'
            return
          }

          this.process.form = true

          // SAVE TO REST API
          await post(`admin/produk/${this.form.layanan_kode}/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            if (res.code === 200) {
              this.process.form = false
              
              this.dialog.siak = false

              this.fetchProduct()
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async save_delete () {
        this.message.error = ''

        this.process.form = true

        // SAVE TO REST API
        await post(`admin/produk/${this.selected.detail.prod_layanan_kode}/delete`, {
          data: {
            ids: [this.selected.detail.id]
          }
        })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.form = false
            
            this.dialog.delete = false

            this.fetchProduct()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  .v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
    min-height: 64vh;
    left: calc(24px - 1px);
  }

  .v-timeline-item__divider {
    min-width: 50px;
    justify-content: start !important;
    left: -34px;
  }

  .log_note p {
    margin-bottom: 2px;
  }
</style>